
export const PROJECTS_IN_PROGRESS_PAGE_COUNT = 3;
export const FUNDED_PROJECTS_PAGE_COUNT = 6;

// keep in sync with top level search categories
export const subjects = {
	"Life Skills" : {iconValue: "life-skills", searchFilter: "subject5=-5", alwaysShow: true},
	"Health, Sports, & Wellness" : {iconValue : "health-sports-and-wellness", searchFilter: "subject2=-2", alwaysShow: true},
	"Social Studies" : {iconValue: "social-studies", searchFilter: "subject3=-3", alwaysShow: true},
	"Literacy & Language" : {iconValue: "literacy-language", searchFilter: "subject6=-6", alwaysShow: true},
	"STEM" : {iconValue: "stem", searchFilter: "subject4=-4", alwaysShow: true},
	"Music & The Arts" : {iconValue: "music-arts", searchFilter: "subject1=-1", alwaysShow: true},
	"Students with Disabilities" : {iconValue: "students-with-disabilities", searchFilter: "subject7=-7", alwaysShow: true},
	"Warmth, Care & Hunger" : {iconValue: "warmth-care", searchFilter: "subject8=-8", alwaysShow: true},
	"Racial Justice & Representation" : {iconValue: "racial-justice", searchFilter: "subject9=-9", alwaysShow: false}
};

export const loadingStatuses = {
	LOADING_FULLY_FUNDED_DONATIONS: "loadingFullyFundedDonations",
	LOADING_IN_PROGRESS_DONATIONS: "loadingInProgressDonations",
	LOADING_FULLY_FUNDED_PROJECTS: "loadingFullyFundedProjects",
	LOADING_IN_PROGRESS_PROJECTS: "loadingInProgressProjects",
	FULLY_FUNDED_END_REACHED: "fullyFundedDonationsEndReached",
	IN_PROGRESS_END_REACHED: "inProgressDoantionsEndReached"
};
